/**
 * video.js does:
 * 1. makes videos with class 'video-responsive' responsive
 * 2. replaces videos with images when video has class 'poster-only'
 * 3. start and pause video when you click on it
 */

import $ from 'jquery';
import { isMobile } from './utils';

const $mediaWrapper = $('.media');
const $responsiveVideos = $('.video-responsive');
const $videos = $('video');

function init() {
  replaceVideosWithImages();
  bindEvents();
}

function bindEvents() {
  $(document).on('click', 'video', toggleVideoPlay);
}

// we can use poster-only class for videos to prevent videos shown on mobile
function replaceVideosWithImages() {
  if (!isMobile) {
    return false;
  }

  $.each($('.poster-only'), (index, el) => {
    const $el = $(el);

    $el.find('video').remove();

    var img = new Image();
    img.src = $el.find('video').attr('data-poster');

    $el.prepend(img);
  });
}

function toggleVideoPlay(evt){
  var currVideo = evt.originalEvent.srcElement;

  if (currVideo.paused) {
    // pause all other videos on the site
    $.each($videos.not(currVideo), (index, el) => {
      el.pause();
    });

    return currVideo.play();
  }

  currVideo.pause();
}

function checkResponsiveVideos(){
  if (!$responsiveVideos.size()) {
    return false;
  }

  const width = $mediaWrapper.outerWidth();
  const height = (width / 16) * 9;

  $responsiveVideos.css({
    width : width + 'px',
    height : height + 'px'
  });
}

export default {
  init
};
